import { jsx as e } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { bindForwardedRef as x } from "@givebutter/react-util";
import { useSortable as y, SortableContext as v, verticalListSortingStrategy as w } from "@dnd-kit/sortable";
import { useSortable as E } from "@dnd-kit/sortable";
import { CSS as N } from "@dnd-kit/utilities";
import { CSS as J } from "@dnd-kit/utilities";
import { faGripDotsVertical as h } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as C } from "@fortawesome/react-fontawesome";
import { twMerge as s } from "tailwind-merge";
const G = ({ strategy: r = w, ...t }) => /* @__PURE__ */ e(v, { strategy: r, ...t }), m = i(
  ({ itemId: r, className: t, ...o }, a) => {
    const { attributes: d, listeners: p, setNodeRef: f, transform: b, transition: c, isDragging: u } = y({
      id: r
    }), S = {
      transform: N.Transform.toString(b),
      transition: c
    };
    return /* @__PURE__ */ e(
      "div",
      {
        ref: (n) => {
          f(n), x(a, n);
        },
        style: S,
        ...d,
        ...p,
        ...o,
        "data-dragging": u,
        className: s("group", t)
      }
    );
  }
);
m.displayName = "SortableItem";
const l = i(
  ({ className: r, ...t }, o) => /* @__PURE__ */ e(
    "div",
    {
      ref: o,
      className: s(
        "relative flex w-full items-center gap-x-2 rounded border border-gray-200 bg-white py-2 pl-5 pr-4 text-sm font-medium hover:border-gray-300 hover:bg-gray-50 group-[[data-dragging=true]]:cursor-grabbing group-[[data-dragging=true]]:shadow-xl",
        r
      ),
      ...t
    }
  )
);
l.displayName = "SortableCard";
const g = i(
  ({ icon: r = h, className: t, ...o }, a) => /* @__PURE__ */ e(
    C,
    {
      ref: a,
      icon: r,
      className: s(
        "absolute left-1 hidden text-gray-500 group-hover:inline-block",
        t
      ),
      ...o
    }
  )
);
g.displayName = "SortableGrip";
const M = G, T = m, V = l, q = g;
export {
  J as CSS,
  V as Card,
  q as Grip,
  T as Item,
  M as Root,
  G as Sortable,
  l as SortableCard,
  g as SortableGrip,
  m as SortableItem,
  E as useSortable
};
